import React from "react";
import "./PartnersSection.css";
import logo from "../assets/logo.png"; // 로고 이미지 경로
import logo1 from "../assets/6p_partners/1.png";
import logo2 from "../assets/6p_partners/2.png";
import logo3 from "../assets/6p_partners/3.png";
import logo4 from "../assets/6p_partners/4.png";
import logo5 from "../assets/6p_partners/5.png";
import logo6 from "../assets/6p_partners/6.png";
import logo7 from "../assets/6p_partners/7.png";
import logo8 from "../assets/6p_partners/8.png";
import logo9 from "../assets/6p_partners/9.png";
import logo10 from "../assets/6p_partners/10.png";
import logo11 from "../assets/6p_partners/11.png";
import logo12 from "../assets/6p_partners/12.png";
import logo13 from "../assets/6p_partners/13.png";
import logo14 from "../assets/6p_partners/14.png";

function PartnersSection() {
  const logos1 = [logo1, logo2, logo3, logo4, logo5, logo6, logo7];
  const logos2 = [logo8, logo9, logo10, logo11, logo12, logo13, logo14]

  return (
    <section className="partners-section">
      <div className="partners-title"><img src={logo} alt="채움기획" /> <h2 className="text-x">x</h2> <h2 className="text-partner">파트너사</h2></div>
      <p className="partners-subtitle">
        채움기획은 고객님들과 함께 꾸준한 매출 성장을 이뤄냅니다.
      </p>

      {/* 첫 번째 슬라이드 */}
      <div className="partners-section-logo-slider">
        <div className="partners-section-logo-track">
          {logos1.map((logo, index) => (
            <img src={logo} alt={`logo-${index}`} className="logo" key={index} />
          ))}
          {logos1.map((logo, index) => (
            <img src={logo} alt={`logo-${index}-copy`} className="logo" key={`copy-${index}`} />
          ))}
          {logos1.map((logo, index) => (
            <img src={logo} alt={`logo-${index}`} className="logo" key={index} />
          ))}
          {logos1.map((logo, index) => (
            <img src={logo} alt={`logo-${index}-copy`} className="logo" key={`copy-${index}`} />
          ))}          
        </div>
      </div>

      {/* 두 번째 슬라이드 */}
      <div className="partners-section-logo-slider">
        <div className="partners-section-logo-track">
          {logos2.map((logo, index) => (
            <img src={logo} alt={`logo-${index}`} className="logo" key={index} />
          ))}
          {logos2.map((logo, index) => (
            <img src={logo} alt={`logo-${index}-copy`} className="logo" key={`copy-${index}`} />
          ))}
          {logos2.map((logo, index) => (
            <img src={logo} alt={`logo-${index}`} className="logo" key={index} />
          ))}
          {logos2.map((logo, index) => (
            <img src={logo} alt={`logo-${index}-copy`} className="logo" key={`copy-${index}`} />
          ))}          
        </div>
      </div>
    </section>
  );
}

export default PartnersSection;
